export default {
  getCPC: state => state.cpc,
  getNotificationsNames: state => state.notificationsNames,
  getRefUrl: state => state.refUrl,
  getClickId: state => state.clickid,
  getCampaignId: state => state.campaignId,
  getPublisherId: state => state.publisherId,
  getTwoStepsRegistration: state => state.twoStepRegistration,
  getUserAvailableGames: state => state.userDetails.availableGames,
  getSimpleRegistration: state => state.simpleRegistration,
  getSplashUrl: state => state.splashUrl,
  getAvailableFlowsInfo: state => state.availableFlows,
  getCorrelationId: state => state.correlationId,
  getPushNotificationsPublicKey: state => state.pushNotificationsPublicKey,
  getConnectionPoints: state => state.connectionPoints,
  getInstallPromptEvent: state => state.installPromptEvent,
  getActiveModal: state => state.activeModals[state.activeModals.length - 1],
};



// WEBPACK FOOTER //
// ./src/store/modules/common/getters.js